import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import Main from "../../components/layout/Main";
import MdiIcon from "../../components/device/app/MdiIcon";
import { deviceIcon } from "../../components/device/app/deviceTheme";
import { HIDDEN_CATEGORY_ID, REMOTE_PATHS, canAddCategory } from "./remoteUtils";
import "../../assets/styles/app-remotes.css";

// The app's Choose Category (app/screens/HashhRemote/AddRemoteModal.js): the
// IRDB's remote categories in the boxes of the app's "+" sheet. Categories
// without a remote layout here are dimmed, as in the app.
// Location state: { blaster, categories, steps }.
function ChooseCategory() {
  const { state } = useLocation();
  const history = useHistory();
  const categories = (state?.categories ?? []).filter((category) => category && category.id !== HIDDEN_CATEGORY_ID);

  if (!state?.blaster || !categories.length) return <Redirect to={REMOTE_PATHS.UNIVERSAL} />;

  const choose = (category) =>
    history.push(REMOTE_PATHS.ADD_BRAND, { blaster: state.blaster, category, steps: state.steps + 1 });

  return (
    <Main header="stack" title="Choose Category" hideTabBar>
      <div className="hx-create-grid hx-remote-categories">
        {categories.map((category, index) => (
          <button
            key={category.id}
            type="button"
            className="hx-create-box"
            style={{ "--i": index }}
            disabled={!canAddCategory(category)}
            onClick={() => choose(category)}
          >
            <MdiIcon path={deviceIcon(category.name_en)} size={35} />
            {category.name_en}
          </button>
        ))}
      </div>
    </Main>
  );
}

export default ChooseCategory;
